<app-background-card
  title="{{ 'selecthorAdmin.provider.invoices.page.title' | transloco }}"
  titleTestId="invoice-list-header"
  testId="invoice-list-card"
>
  <p-tabs appTabsUnsavedReveal [(value)]="activeTabIndex" scrollable>
    <p-tablist data-testid="project-user-management-tablist" [ngClass]="'mb-5'">
      <p-tab value="customerInvoices"
        >{{ 'selecthor-admin.invoices.tab.customer' | transloco }}
      </p-tab>
      <p-tab value="providerInvoices"
        >{{ 'selecthor-admin.invoices.tab.provider' | transloco }}
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel
        value="customerInvoices"
        [attr.data-testid]="'selecthor-admin-invoices-tab-customer-panel'"
      >
        TBD
      </p-tabpanel>
      <p-tabpanel
        value="providerInvoices"
        [attr.data-testid]="'selecthor-admin-invoices-tab-provider-panel'"
      >
        <app-selecthor-admin-provider-invoices-list />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</app-background-card>
